// extracted by mini-css-extract-plugin
export default {"searchResults":"MobileRoutingView_searchResults__4V4fR"};